var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"kt-menu__item",class:{
    'kt-menu__item--submenu': _vm.menu.submenu,
    'kt-menu__item--active': _vm.activeMenu(_vm.menu)
  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":_vm.submenuToggle(_vm.menu)}},[_c('KTMenuItemText',{attrs:{"menu":_vm.menu}}),(_vm.menu.submenu)?_c('KTMenuSubmenu',{attrs:{"submenu":_vm.menu.submenu,"parentMenu":_vm.menu}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }